import {Component, OnInit, ViewChild} from '@angular/core';
import {ListClientsDataService} from "../listclientsdataservice";
import {ClimateComputer, ClientList} from "../listclientsdata";
import {UrlBuilder} from "../../url-builder/url.builder";
import {ExpansionPanelComponent} from "@progress/kendo-angular-layout";
import {environment} from "../../../environments/environment";
import {interval, Subscription} from "rxjs";
import {ClientListWithAccess} from "../clientlistwithaccess";

@Component({
  selector: 'app-listclients',
  templateUrl: './listclients.component.html',
  styleUrls: ['./listclients.component.css']
})
export class ListclientsComponent implements OnInit {
  @ViewChild("panel", { static: false }) public panel: ExpansionPanelComponent | undefined;

  climateComputerList: ClimateComputer[] | undefined;
  expanded: boolean = false;
  currentClient: string = "--current client--";
  private updateSubscription: Subscription | undefined;

  constructor(private listClientsDataService :ListClientsDataService) {
    console.log('LIST VIEW Construct');
  }

  ngOnInit(): void {
    console.log('LIST VIEW Init');
    let urlBuilder: UrlBuilder = new UrlBuilder();
    this.currentClient = urlBuilder.GetCurrentClient();
    this.GetClientList();
  }

  ngOnDestroy(): void {
    this.updateSubscription?.unsubscribe();
  }

  ReSubscribe(): void
  {
    this.updateSubscription = interval(environment.interval).subscribe(
      (val) => {
        this.GetClientList();
      });
  }

  GetClientList() : void
  {
      this.updateSubscription?.unsubscribe();
      this.listClientsDataService.GetData().subscribe({
        next: listClient => {
          this.ReSubscribe();

          this.climateComputerList = ClientListWithAccess.Filter(listClient.client_list);

          this.climateComputerList.sort((a,b)=> a.idNr.localeCompare(b.idNr ));
          for(let computer of this.climateComputerList)
          {
              this.CalculateTimeinterval(computer);
          }
        }
      });
  }

  CalculateTimeinterval(computer : ClimateComputer):void
  {
    computer.lastSeen        = new Date(computer.lastSeen);
    computer.lastScan         = new Date(computer.lastScan);
  }

  onReload(event?: MouseEvent) {
    this.GetClientList();
  }

  onActivate(event: any) {
    this.expanded = false;
    this.panel?.toggle();
    let urlBuilder: UrlBuilder = new UrlBuilder();
    urlBuilder.SetCurrentClient(event.target.id);
    this.currentClient = urlBuilder.GetCurrentClient();
    console.log('INFO TARGET: ' + urlBuilder.GetCurrentClient());
  }

  // "<img src=assets/img/offline.png>"
  Filter(status: number):string {
    switch(status)
    {

      case 1:
        return "assets/img/online.png";
      case 2:
        return "assets/img/asymmetric_network_24.png";

      default:
        return "assets/img/offline.png";

    }
  }
}
